import { useContext } from 'react'

import { ModuleNavContext } from 'src/context/module-nav-context'

export default function useModuleNavbar() {
    const context = useContext(ModuleNavContext)

    if (!context) {
        throw new Error('Wrap this component in ModuleNavContext')
    }

    return context
}
